import { all } from "redux-saga/effects";
import { thuPhiSaga } from "./thuPhiSaga";
import { thuPhiNhapHocSaga } from "./thuPhiNhapHocSaga";
import { thuPhiTamThuSaga } from "./thuPhiTamThuSaga";
import { thuPhiTheoLopSaga } from "./thuPhiTheoLopSaga";
import { thuPhiTuyenSinhSaga } from "./thuPhiTuyenSinhSaga";

export default function* thuPhiSagaWrapper() {
  yield all([
    thuPhiSaga(),
    thuPhiNhapHocSaga(),
    thuPhiTamThuSaga(),
    thuPhiTheoLopSaga(),
    thuPhiTuyenSinhSaga(),
  ]);
}
